module.exports = __webpack_public_path__ + "static/media/partitionHardwareMainImg.cdf80724.png";